import React from 'react';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Button } from '../components/ui/button';
import { Loader2 } from 'lucide-react';

export function LoginForm({ email, setEmail, password, setPassword, loading, onSubmit, t }) {
  return (
    <form onSubmit={onSubmit} className="space-y-4">
      <div className="space-y-2">
        <Label className="text-slate-700 font-semibold text-sm">{t('email')}</Label>
        <Input type="email" data-testid="login-email-input" placeholder={t('emailPlaceholder')}
          value={email} onChange={(e) => setEmail(e.target.value)}
          className="rounded-xl h-10 border-slate-200 text-sm" required />
      </div>
      <div className="space-y-2">
        <Label className="text-slate-700 font-semibold text-sm">{t('password')}</Label>
        <Input type="password" data-testid="login-password-input" placeholder={t('passwordPlaceholder')}
          value={password} onChange={(e) => setPassword(e.target.value)}
          className="rounded-xl h-10 border-slate-200 text-sm" required />
      </div>
      <Button type="submit" data-testid="login-submit-btn" disabled={loading} className="w-full btn-primary h-11">
        {loading ? <><Loader2 className="w-4 h-4 mr-2 animate-spin" />{t('loggingIn')}</> : t('login')}
      </Button>
    </form>
  );
}
